
/**
 * 动态加载css文件
 * @param {*} url
 * @param {*} isCache
 */
export function loadCSS(url,isCache=false) {
    let element = document.createElement("link");
    element.setAttribute("rel", "stylesheet");
    element.setAttribute("type", "text/css");
    element.setAttribute("id","detailCssSource")

    // 检查是否已经加载过这个CSS文件
    let existingLink = document.querySelector(`link[href="${url}"]`);
    if (existingLink) {
        console.log("CSS file already loaded:", url);
        return;
    }

    if (isCache) {
        element.setAttribute("href", url + "?t=" + new Date().getTime());
    } else {
        element.setAttribute("href", url);
    }

    document.head.appendChild(element);
  }
  
  /**
   * 动态加载js文件
   * @param {*} src
   * @param {*} callback
   *   loadScript("",function(){
   *   console.log("加载成功")
   * })
   * var that = this; 在方法里面使用that
   */
  export function loadJS(jsUrl, callback,isCache = false) {
    var script = document.createElement('script');
    script.setAttribute("id","detailJSSource")
    var head = document.head;
    script.type = 'text/JavaScript';
    if (isCache) {
        script.src = jsUrl + "?t=" + new Date().getTime();
    }else {
      script.src = jsUrl
    }
    if (script.addEventListener) {
      script.addEventListener('load', callback, false);
    }
    head.appendChild(script);
  }
  
  /**
   * 动态加载js文件
   * @param {*} src
   * @param {*} callback
   *   loadScript("",function(){
   *   console.log("加载成功")
   * })
   * var that = this; 在方法里面使用that
   */
  export function loadBodyJS(src, callback,isCache = false) {
    

    // 添加时间戳以避免缓存
    const scriptUrl = isCache ? src + "?t=" + new Date().getTime() : src;


    // 创建script元素
    var script = document.createElement('script');
    script.type = 'text/javascript'; // 修正类型为text/javascript
    script.setAttribute("id","detailJSSource")
    // 监听加载完成事件
    script.onload = function() {
        console.log("加载成功");
        if (typeof callback === 'function') {
            callback();
        }
    };

    // 监听错误事件
    script.onerror = function() {
        console.error("加载失败");
    };

    script.src = scriptUrl;
    document.body.appendChild(script);
  }
  

  export function removeAllHeaderChildren(scriptUrls, callback) {
    var header = document.querySelector('header');
    while (header.firstChild) {
        header.removeChild(header.firstChild);
    }
  }

  export function removeAllDetailSource() {
    var elementsCssToRemove = document.querySelectorAll('[id="detailCssSource"]');
    console.log(elementsCssToRemove)
    // 遍历所有找到的元素
    elementsCssToRemove.forEach(function(element) {
      // 移除元素
      if (element.parentNode) {
        element.parentNode.removeChild(element);
      }
    });

    var elementsJsToRemove = document.querySelectorAll('[id="detailJSSource"]');
    console.log(elementsJsToRemove)
    // 遍历所有找到的元素
    elementsJsToRemove.forEach(function(element) {
      // 移除元素
      if (element.parentNode) {
        element.parentNode.removeChild(element);
      }
    });
   
  }